import React from "react";
import { Link } from "react-router-dom";

export const AGB_URL = "https://info.pruefdoc-pro.de/agb.html";

export function LegalFooter({ className = "" }) {
  const cls = "hover:text-primary hover:underline transition-colors";
  return (
    <footer className={`text-center text-xs text-slate-400 ${className}`} data-testid="legal-footer">
      <nav className="inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <Link to="/impressum" className={cls} data-testid="footer-impressum-link">Impressum</Link>
        <span aria-hidden>·</span>
        <Link to="/datenschutz" className={cls} data-testid="footer-datenschutz-link">Datenschutz</Link>
        <span aria-hidden>·</span>
        <a href={AGB_URL} target="_blank" rel="noopener noreferrer" className={cls} data-testid="footer-agb-link">AGB</a>
      </nav>
    </footer>
  );
}
